import { FC } from 'react';
import appstore from 'assets/icons/appstore.svg';
import logo from 'assets/icons/kapi-dk-logo.svg';
import playmarket from 'assets/icons/playmarket.svg';
import rustore from 'assets/icons/rustore.svg';

import styles from './styles.module.scss';

export const MobileStub: FC = () => {
  return (
    <div className={styles['stub']}>
      <img className={styles['stub__logo']} src={logo} alt="logo" />
      <div className={styles['stub__header']}>
        Мобильная версия в<br />
        разработке...
      </div>
      <div className={styles['stub__desc']}>
        Пока что можешь скачать <br />
        приложение:
      </div>
      <div className={styles['stub__links']}>
        <a
          className={styles['stub__link']}
          href="https://www.rustore.ru/catalog/app/com.capypara.capypara"
        >
          <img
            className={styles['stub__link-img']}
            src={rustore}
            alt="rustore"
          />
        </a>
        <a
          className={styles['stub__link']}
          href="https://play.google.com/store/apps/details?id=com.capypara.capypara&pli=1"
        >
          <img
            className={styles['stub__link-img']}
            src={playmarket}
            alt="playmarket"
          />
        </a>
        <a
          className={styles['stub__link']}
          href="https://apps.apple.com/ru/app/капипара/id6677054611"
        >
          <img
            className={styles['stub__link-img']}
            src={appstore}
            alt="appstore"
          />
        </a>
      </div>
    </div>
  );
};
